var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardTogetherWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "55mm",
    height: "13mm",
    viewBox: "0 0 155.9 36.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.8,16V.6h11.6v3.9h-7v1.8h6.8v3.9h-6.8v5.8h-4.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,.4c4.7,0,8.4,3.2,8.4,7.9s-3.7,7.9-8.4,7.9-8.4-3.2-8.4-7.9S56.2.4,61,.4ZM61,4.5c-2.2,0-3.7,1.7-3.7,3.8s1.4,3.8,3.7,3.8,3.7-1.7,3.7-3.8-1.4-3.8-3.7-3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4,16l-2.1-4.9h-1.7v4.9h-4.6V.6h8.2c3.6,0,5.5,2.4,5.5,5.3s-1.5,4-2.8,4.6l2.8,5.4h-5.3ZM78.5,4.5h-2.8v2.7h2.8c.8,0,1.5-.5,1.5-1.4s-.7-1.3-1.5-1.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3,16l-2-8.7-2,8.7h-4.9l-4.4-15.3h5.2l2,9.4,2.3-9.4h3.5l2.3,9.4,2-9.4h5.2l-4.4,15.3h-4.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.1,16l-.6-2h-5.9l-.6,2h-5l5.7-15.3h5.8l5.7,15.3h-5ZM114.5,4.7l-1.7,5.4h3.5l-1.7-5.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4,16l-2.1-4.9h-1.7v4.9h-4.6V.6h8.2c3.6,0,5.5,2.4,5.5,5.3s-1.5,4-2.8,4.6l2.8,5.4h-5.3ZM131.4,4.5h-2.8v2.7h2.8c.8,0,1.5-.5,1.5-1.4s-.7-1.3-1.5-1.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5,16V.6h6.9c4.8,0,8.4,2.8,8.4,7.7s-3.6,7.7-8.4,7.7h-6.9ZM144.2,11.9h2.2c2.3,0,3.7-1.7,3.7-3.6s-1.2-3.6-3.7-3.6h-2.2v7.2Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.1,36.1v-15.2h-4.3v-1.6h10.3v1.6h-4.3v15.2h-1.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,36.5c-5,0-8.7-3.8-8.7-8.7s3.7-8.7,8.7-8.7,8.7,3.8,8.7,8.7-3.7,8.7-8.7,8.7ZM58.5,34.8c4.1,0,7-3,7-7.1s-2.9-7.1-7-7.1-7,3-7,7.1,2.9,7.1,7,7.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,36.5c-5,0-8.6-3.8-8.6-8.7s3.6-8.7,8.6-8.7,7.2,2.4,8.3,6.1h-1.8c-1-2.7-3.4-4.5-6.5-4.5s-6.8,3-6.8,7.1,2.9,7.1,6.9,7.1,6.3-2.5,6.8-5.8h-5.6v-1.6h7.2v.7c0,4.6-3.7,8.3-8.4,8.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,36.1h-10.4v-16.7h10.1v1.6h-8.4v5.4h8v1.6h-8v6.7h8.7v1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3,36.1v-15.2h-4.3v-1.6h10.3v1.6h-4.3v15.2h-1.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1,27.9h-8.9v8.2h-1.7v-16.7h1.7v6.9h8.9v-6.9h1.7v16.7h-1.7v-8.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,36.1h-10.4v-16.7h10.1v1.6h-8.4v5.4h8v1.6h-8v6.7h8.7v1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,29.4v6.7h-1.7v-16.7h5.9c3.7,0,5.8,2.1,5.8,5s-1.2,3.9-3.3,4.6l3.2,7.1h-1.8l-3-6.7c-.3,0-.5,0-.8,0h-4.2ZM144.1,21v6.9h4.2c2.9,0,4-1.6,4-3.5s-1.1-3.4-3.9-3.4h-4.3Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9,22.3c.4-.1.8-.2,1.1-.4-.1.4-.2.8-.3,1.2-1.5,5.6-1.4,9.7-1,12.3-2.7-.8-5.3-2.3-7.5-4.5-2.2-2.2-3.7-4.8-4.5-7.6.9.1,2.1.2,3.4.2,2.3,0,5.3-.3,8.7-1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4,30.9c-3.5,3.4-8,5.2-12.5,5.2-.3-.9-1.2-5,.6-11.7,1-3.9,3.2-6.5,4.1-7.4.3-.3.5-.5.6-.6l1.6,1.6c.9.9,2.5.4,2.7-.8l1.6-8.3c.2-1.1-.7-2.1-1.8-1.8l-8.3,1.6c-1.3.2-1.8,1.8-.8,2.7l1.6,1.6c-.1.1-.3.3-.6.6-1,.9-3.5,3-7.5,4.1-6.3,1.7-10.4.9-11.6.6,0-4.5,1.8-8.9,5.2-12.4,6.9-6.9,18.2-6.9,25.1,0,6.9,6.9,6.9,18.2,0,25.1Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardTogetherWhiteLogo);
export default __webpack_public_path__ + "static/media/ForwardTogetherWhiteLogo.6b0dd616be3dad8536e02067570ed26e.svg";
export { ForwardRef as ReactComponent };